import muster from '@dbk-legacy/muster';
import { getValues, watchValues } from '@dbk-legacy/muster/utils';
import { variable } from '@dbk-legacy/muster/helpers';
import lget from 'lodash/get';

import ui from '../data/ui.json';

let TIMER_ID = 0;
let RESET_TIMES = 0;
let COUNTDOWN_ID = 0;
let COUNTDOWN_SEC = lget(ui, 'inactive.countdownSeconds');
let LOGOUT_TIMES = 0;
let CURRENT_PATH = '';

export default () =>
  muster()
    .path('inactive.timeout', variable(0))
    .path('inactive.countdown', variable(COUNTDOWN_SEC))
    .path('inactive.startTimer', {
      call: async ({ req }, { get, set }) => {
        TIMER_ID = setInterval(async () => {
          const [inactiveTimeout] = await getValues(get(['inactive.timeout']));
          set('inactive.timeout', inactiveTimeout + 1);
                    
          if(window.dapError && window.dapError == true){
            set('inactive.countdown', 0);  
          }

        }, 1000);
      }
    })
    .path('inactive.resetTimer', {
      call: async ({ req }, { set }) => {
        set('inactive.timeout', 0);
      }
    })
    .path('inactive.stopTimer', {
      call: async ({ req }, { set }) => {
        clearInterval(TIMER_ID);
        set('inactive.timeout', 0);
      }
    })
    .path('inactive.startCountdownTimer', {
      call: async ({ req }, { get, set }) => {  
      var countDownTimer = new Date().getTime() + 60000;  // add 60 seconds to current time

      COUNTDOWN_ID = setInterval(function() {
        var currentTime = new Date().getTime();
        var remainingTime = countDownTimer - currentTime; 
        var seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
        set('inactive.countdown', seconds);
      }, 1000);
      }
    })
    .path('inactive.stopCountdownTimer', {
      call: async ({ req }, { get, set }) => {
        clearInterval(COUNTDOWN_ID);
        set('inactive.countdown', COUNTDOWN_SEC);
      }
    })
    .path('inactive.stopTimerAtZero', {
      call: async ({ req }, { get, set }) => {
        clearInterval(COUNTDOWN_ID);
        set('inactive.countdown', 0);
      }
    })

    .path('inactive.resetTimerEvent', (requests, { get }) =>
      watchValues(get('ui.history.currentLocation.pathname'))
        .map(([pathname]) => {
          RESET_TIMES++;

          return {
            path: 'inactive.resetTimerEvent',
            value: RESET_TIMES,
          }
        })
    )
    .path('inactive.onPathChangedEvent', {
      call: async ({ req }, { get, set, call }) => {
        const assets = [
          'alternatives',
          'bonds',
          'cash',
          'equities',
          'fxForwards',
          'loans',
          'mmInstruments',
          'optionsDerivatives',
          'various',
        ];

        assets.forEach(item => {
          call(`ui.state.portfolio.${item}.resetSort`);
          set(`portfolio.${item}.positions.pageOffset`, 0);
        });
      }
    })
    .path('inactive.pathChangedEvent', (requests, { get }) => 
      watchValues(get('ui.history.currentLocation.pathname'))
        .map(([pathname]) => {
          CURRENT_PATH = pathname;

          return {
            path: 'inactive.pathChangedEvent',
            value: CURRENT_PATH,
          }
        })
    )
    .path('inactive.setPopupVisibility', {

      call: async ({ req }, { get, set, call }) => {

        const visibleFlag = req.args[0];

          await set('logoutPopup.isVisible', visibleFlag);

      }

    }) 
    .path('inactive.autoLogoutEvent', (requests, { get }) =>
      watchValues(get('inactive.countdown'))
        .map(([countdown]) => {
          if (countdown === 0) {
            LOGOUT_TIMES++;
          }

          return {
            path: 'inactive.autoLogoutEvent',
            value: LOGOUT_TIMES,
          }
        })
    )

    .path('trade.route.path', variable(null))

    .path('logoutPopup.isVisible', variable(false));